// Slider on the Threat page

export default function initSlickSlider() {
  $('#slick').slick({
    centerPadding: '60px',
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    ],
    prevArrow: $('#slickPrev'),
    nextArrow: $('#slickNext'),
  });

  if (document.getElementById('ipData')) {
    new PerfectScrollbar('#ipData', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });
  }

  if (document.getElementById('hashData')) {
    new PerfectScrollbar('#hashData', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });
  }

  if (document.getElementById('domainData')) {
    new PerfectScrollbar('#domainData', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });
  }

  if (document.getElementById('urlData')) {
    new PerfectScrollbar('#urlData', {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });
  }

  (function () {
    const links = document.querySelectorAll('.threat h2 a');

    if (!links.length) {
      return;
    }

    links.forEach((link) => {
      link.removeAttribute('target');
    });
  }());
}
